import { NavigationControl } from '@components/NavigationControl'
import { useCallback, useMemo } from 'react'
import { XStack } from 'tamagui'

interface ICourseContentNavigationProps {
  onPreviousPress?: () => void
  onNextPress?: () => void
  hasPreviousContent?: boolean
  hasNextContent?: boolean
  visibilityType?: 'top' | 'bottom'
  isLoading?: boolean
}

export function CourseContentNavigation({
  onPreviousPress,
  onNextPress,
  hasPreviousContent = false,
  hasNextContent = false,
  visibilityType = 'bottom',
  isLoading = false,
}: ICourseContentNavigationProps) {
  const handlePreviousPress = useCallback(() => {
    if (hasPreviousContent && onPreviousPress) {
      onPreviousPress()
    }
  }, [hasPreviousContent, onPreviousPress])

  const disableNextButton = useMemo(() => {
    return isLoading || !hasNextContent
  }, [isLoading, hasNextContent])

  const disablePreviousButton = useMemo(() => {
    return isLoading || !hasPreviousContent
  }, [isLoading, hasPreviousContent])

  const handleNextPress = useCallback(() => {
    if (hasNextContent && onNextPress) {
      onNextPress()
    }
  }, [hasNextContent, onNextPress])

  if (visibilityType === 'top') {
    return (
      <XStack alignItems="center" justifyContent="space-between" w="100%">
        <NavigationControl
          testID="navigation-left-button"
          action={handlePreviousPress}
          chevronDirection="left"
          label="Anterior"
          size={24}
          disabled={disablePreviousButton}
          chevronColor="$icon-primary"
        />

        <NavigationControl
          testID="navigation-right-button"
          action={handleNextPress}
          chevronDirection="right"
          label="Próximo"
          size={24}
          disabled={disableNextButton}
          chevronColor="$icon-primary"
        />
      </XStack>
    )
  }

  return (
    <XStack borderRadius={4} height={52} alignItems="center">
      <NavigationControl
        testID="navigation-left-button"
        action={handlePreviousPress}
        chevronDirection="left"
        size={24}
        disabled={!hasPreviousContent}
        chevronColor="$icon-primary"
        width={52}
        height={52}
      />
      <NavigationControl
        testID="navigation-right-button"
        action={handleNextPress}
        chevronDirection="right"
        size={24}
        disabled={!hasNextContent}
        chevronColor="$icon-primary"
        width={52}
        height={52}
      />
    </XStack>
  )
}
